export default __webpack_public_path__ + "static/media/upload-onclick.716c81d1.svg";